import { ModelError } from './ModelError';

export const FORBIDDEN_ERROR_NAME = 'FORBIDDEN_ERROR';

export class ForbiddenError extends ModelError {
  public readonly name: string = FORBIDDEN_ERROR_NAME;
}
